class QuickBuyCard extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (!this.els?.button?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.button.elements.forEach((buttonEl) => {
      this.listeners.add(buttonEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    this.removeActive()

    const currentButton = event.currentTarget
    const newVariantID = currentButton.dataset.id
    const available = currentButton.dataset.available === 'true'

    if (currentButton.getAttribute('data-quick-link-to-variant') === 'true') {
      currentButton.setAttribute('aria-pressed', 'true')

      this.els?.submitWrapButtons?.element.setAttribute('aria-hidden', true)
      this.els?.submitWrapLinks?.element.setAttribute('aria-hidden', false)

      const variantURL = currentButton.getAttribute(
        'data-quick-link-to-variant-url',
      )

      this.els.variantLink.element.href = variantURL
    } else {
      currentButton.setAttribute('aria-pressed', 'true')
      this.els.formID.element.value = newVariantID
      this.els.submit.element.disabled = !available
      this.els.submitText.element.innerHTML = available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut

      this.els.bis.element.setAttribute('aria-hidden', available)
      this.els.submit.element.setAttribute('aria-hidden', !available)

      const currentProductUrl =
        this.els.bis.element.getAttribute('data-product-url')
      const tempUrl = new URL(currentProductUrl, window.location.origin)
      tempUrl.searchParams.set('variant', newVariantID)
      this.els.bis.element.setAttribute(
        'data-product-url',
        `${tempUrl.pathname}${tempUrl.search}`,
      )

      this.els?.submitWrapButtons?.element.setAttribute('aria-hidden', false)
      this.els?.submitWrapLinks?.element.setAttribute('aria-hidden', true)
    }
  }

  removeActive () {
    this.els.button.elements.forEach((buttonEl) => {
      buttonEl.setAttribute('aria-pressed', 'false')
    })
  }
}

if (!customElements.get('quick-buy-card')) {
  customElements.define('quick-buy-card', QuickBuyCard)
}
